module.exports = __webpack_public_path__ + "img/school-b.1a64507d.png";